import DatePicker from "react-datepicker";
import { FaFileExport } from "react-icons/fa";
import * as XLSX from "xlsx";
import DataTable from "./DataTable";

const CREDIT_LEFT_HEADER = ["Total Credit", "Amount Paid", "Amount Left", "Guest", "Address", "Email", "ID", "Phone"];

const CreditLeftSection = ({
    handleRangeType,
    creditLeft,
    showDatepicker,
    startDate,
    endDate,
    handleStartDateChange,
    handleEndDateChange,
    selectedCustomer,
    rangeType,
    rangeLoading,
    rangeError,
    formatDateForApi,
}) => {
    const hasData = creditLeft.length > 0;

    const handleExportExcel = () => {
        const worksheetData = [["Customer", selectedCustomer || "All"]];

        if (rangeType !== "All") {
            worksheetData.push(["Start Date", startDate ? formatDateForApi(startDate) : ""]);
            worksheetData.push(["End Date", endDate ? formatDateForApi(endDate) : ""]);
        }

        worksheetData.push([]);
        worksheetData.push(CREDIT_LEFT_HEADER);

        creditLeft.forEach((info) => {
            worksheetData.push([
                info.TotalCredit,
                info.AmountPaid,
                info.amountleft,
                info.guest,
                info.guestAddress,
                info.guestEmail,
                info.guestID,
                info.guestPhone,
            ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        worksheet["!cols"] = [
            { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 30 },
            { wch: 25 }, { wch: 30 }, { wch: 15 }, { wch: 18 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Credit Left");

        const customerName = (selectedCustomer || "customer").replace(/\s+/g, "_");
        XLSX.writeFile(workbook, `credit-${customerName}-${rangeType || "all"}.xlsx`);
    };

    return (
        <div className="space-y-3 mt-4">
            <div className="flex items-center justify-between flex-wrap gap-3">
                <div className="flex items-center gap-3 flex-wrap">
                    <select
                        onChange={handleRangeType}
                        defaultValue=""
                        className="px-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="" disabled>
                            Please select an option
                        </option>
                        <option value="All">All</option>
                        <option value="Ranged">Range</option>
                    </select>

                    {showDatepicker && (
                        <>
                            <div className="flex items-center gap-1.5 z-50">
                                <label className="text-sm text-gray-600">Start:</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleStartDateChange}
                                    className="w-[120px] px-3 py-1.5 border border-gray-200 rounded-md text-sm z-30"
                                />
                            </div>
                            <div className="flex items-center gap-1.5 z-50">
                                <label className="text-sm text-gray-600">End:</label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={handleEndDateChange}
                                    className="w-[120px] px-3 py-1.5 border border-gray-200 rounded-md text-sm z-30"
                                />
                            </div>
                        </>
                    )}
                </div>

                <button
                    onClick={handleExportExcel}
                    disabled={!hasData}
                    className="flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                    <FaFileExport size={12} />
                    Export
                </button>
            </div>

            <DataTable
                columns={[
                    { key: "TotalCredit", label: "Total Credit" },
                    { key: "AmountPaid", label: "Amount Paid" },
                    { key: "amountleft", label: "Amount Left" },
                    { key: "guest", label: "Guest" },
                    { key: "guestAddress", label: "Address" },
                    { key: "guestEmail", label: "Email" },
                    { key: "guestID", label: "ID" },
                    { key: "guestPhone", label: "Phone" },
                ]}
                rows={creditLeft}
                loading={rangeLoading}
                error={rangeError}
                rowKey={(r, i) => r.guestID || i}
                maxH
            />
        </div>
    );
};

export default CreditLeftSection;